import { AuthPhase } from '@auth/authPhase';
import { ROUTER_NAME } from '@consts';
import { useAuthLifecycle } from '@hooks/useAuthLifecycle';
import BrandLoader from 'components/basic/BrandLoader';
import { useRouter } from 'next/router';
import SessionLostNotice from './SessionLostNotice';

const AuthGuard = ({ children }: { children: React.ReactNode }) => {
  const router = useRouter();
  const { phase, reLogin, error } = useAuthLifecycle();

  if (router.pathname === ROUTER_NAME.VERIFY_EMAIL) {
    return <>{children}</>;
  }

  const brandLoader = (
    <div className='w-full h-dvh'>
      <BrandLoader />
    </div>
  );

  switch (phase) {
    case AuthPhase.AUTHENTICATED:
      return <>{children}</>;
    case AuthPhase.SESSION_LOST:
      return <SessionLostNotice onReLogin={reLogin} />;
    case AuthPhase.EMAIL_UNVERIFIED:
    case AuthPhase.LOGGING_OUT:
      return brandLoader;
    default:
      if (error) return <div>{error.message}</div>;
      return brandLoader;
  }
};

export default AuthGuard;
